module.exports = __webpack_public_path__ + "img/Dragon Esport Logo Template.jpg";